module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei1.svg";